import {Box} from '@mantine/core';
import {BasicButton} from '@packages/ui';
import type {FC} from 'react';
import {REMIND_PASS} from '../../../../config/constants/routes';
import {CommonLink} from '../../../../shared/components/CommonLink';
import {getMailAuthLinkWithParamsHooks} from '../../../../shared/services/getMailAuthLinkWithParamsHooks';
import {LoginForm, type LoginFormContainerProps} from './LoginForm';

type Props = LoginFormContainerProps;

export const LoginPageForMobile: FC<Props> = ({
  useFormLogin,
  submitLogin,
  isLoading,
  hasError,
}) => {
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});

  return (
    <Box className="mb-16 w-full bg-white p-16">
      <div className="w-full flex-col">
        <div className="mb-12 w-full">
          <LoginForm
            useFormLogin={useFormLogin}
            submitLogin={submitLogin}
            isLoading={isLoading}
            hasError={hasError}
          />
        </div>
        <div className="mb-12">
          <CommonLink
            href={REMIND_PASS}
            className="text-base text-link underline"
          >
            パスワードを忘れた方はこちら
          </CommonLink>
        </div>
        <BasicButton
          isPrimary={true}
          isLarge={true}
          onClick={() => {
            location.href = mailAuthLink;
          }}
        >
          新規会員登録
        </BasicButton>
      </div>
    </Box>
  );
};
